import React from "react";
import {Controller} from "react-hook-form";
import {Checkbox, FormControl, FormControlLabel, FormLabel, InputAdornment, MenuItem, Radio, RadioGroup, TextField} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

// コンボボックス
export const CtrlKb1 = (props) => {
  return (
    <Controller
      control = {props.control}
      defaultValue = {props.form.selectList[0].value}
      name = {props.form.itemNo + (Boolean(props.form.cdKb) ? ("_" + props.form.cdKb) : "")}
      render = {({field}) => (
        <TextField
          fullWidth
          label = {props.form.itemNm}
          SelectProps = {{MenuProps: {style: {maxHeight: 200}}}}
          select
          size = "small"
          sx = {{textAlign: "left", zIndex: "0"}}
          {...field}
        >
          {props.form.selectList.map((select) => (
            <MenuItem
              key = {props.form.itemNo + "_" + props.form.cdKb + "_" + select.value}
              value = {select.value}
            >
              {select.subItemNm}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

// ラジオボタン
export const CtrlKb2 = (props) => {
  return (
    <Controller
      control = {props.control}
      defaultValue = {props.form.selectList[0].value}
      name = {props.form.itemNo + (Boolean(props.form.cdKb) ? ("_" + props.form.cdKb) : "")}
      render={({field}) => (
        <FormControl>
          <FormLabel
            id = {"label_" + props.form.itemNo + "_" + props.form.cdKb}
          >
            {props.form.itemNm}
          </FormLabel>
          <RadioGroup
            aria-labelledby = {"label_" + props.form.itemNo + "_" + props.form.cdKb}
            row
            sx = {{pl: 1}}
            {...field}
          >
            {props.form.selectList.map((select) => (
              <FormControlLabel
              control = {<Radio sx = {{p: 0.5}} />}
              key = {props.form.itemNo + "_" + props.form.cdKb + "_" + select.value}
              label = {select.subItemNm}
              value = {select.value}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};

// チェックボックス
export const CtrlKb3 = (props) => {
  return (
    <FormControl>
      <FormControlLabel
        control = {
          <Controller
            control = {props.control}
            defaultValue = {false}
            name = {props.form.itemNo + (Boolean(props.form.cdKb) ? ("_" + props.form.cdKb) : "")}
            render={({field}) => (
              <Checkbox
                icon = {<RadioButtonUncheckedIcon />}
                checkedIcon = {
                  <TaskAltIcon
                    color = "success"
                  />
                }
                color = "default"
                sx = {{p: 0, pr: 1}}
                checked = {field.value}
                onChange = {(e) => field.onChange(e.target.checked)}
                {...field}
              />
            )}
          />
        }
        label = {props.form.itemNm}
        sx = {{m: 0}}
      />
    </FormControl>
  );
};

// 時間入力
export const CtrlKb4 = (props) => {
  return (
    "4"
  );
};

// 所要時間入力
export const CtrlKb5 = (props) => {
  return (
    <TextField
      fullWidth
      inputProps = {{maxLength: "4", style: {textAlign: "right"}}}
      InputProps = {{
        startAdornment:
          <InputAdornment position="start">
            {props.form.itemNm}
          </InputAdornment>,
        endAdornment:
          <InputAdornment position="end">
            {Boolean(props.form.itemLabel) ? props.form.itemLabel : "分"}
          </InputAdornment>
      }}
      size = "small"
      sx = {{mb: 1}}
      type = "tel"
      variant = "standard"
      {...props.register(props.form.itemNo + (Boolean(props.form.cdKb) ? ("_" + props.form.cdKb) : ""))}
    />
  );
};

// 数値入力
export const CtrlKb6 = (props) => {
  return (
    "6"
  );
};

// ON/OFF + 日数と開始日
export const CtrlKb7 = (props) => {
  return (
    "7"
  );
};

// 文字入力
export const CtrlKb8 = (props) => {
  return (
    "8"
  );
};

// 小数値入力
export const CtrlKb9 = (props) => {
  return (
    "9"
  );
};
